import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { AppState } from 'types/_general/AppState';

export type ThunkDispatchType = ThunkDispatch<AppState, void, AnyAction>;

export const useThunkDispatch = () => useDispatch<ThunkDispatchType>();
